﻿import './tracker.config';

import TKModuleFactory from '@tk/utilities/tk.module.factory';
import { headerComponents } from './header';
import TKManager from '@tk/basics/tk.manager';
import TKCarousel from '@tk/components/tk.carousel';
import TKContextMenu from '@tk/components/tk.context.menu';
import TKFlag from '@tk/components/tk.flag';
import TKProductTile from '@tk/components/tk.product.tile';
import TKProductVariants from '@tk/components/tk.product.variants';
import TKTooltip from '@tk/components/tk.tooltip';
import TKDialog from '@tk/components/tk.dialog';
import TKPrice from '@tk/components/tk.price';
import TKStock from '@tk/components/tk.stock';
import TKStaticContent from '@tk/controls/tk.static.content';
import TKArticleList from '@tk/components/tk.article.list';
import TKFavoriteButton from '@tk/components/tk.favorite.button';
import TKFavoriteInfo from '@tk/components/tk.favorite.info';
import TKFormElement from '@tk/controls/tk.form.element';
import TKFormValidator from '@tk/controls/tk.form.validator';
import TKTabsAccordion from '@tk/controls/tk.tabs.accordion';
import TKCompareButton from '@tk/components/compare/tk.compare.button';
import TKSelection from '@tk/controls/tk.selection';
import TKFileUploadArea from '@tk/controls/tk.file.upload.area';
import TKCompareStore from '@tk/components/compare/tk.compare.store';
import TKStatusConsole from '@tk/components/tk.status.console';
import TKClipboard from '@tk/components/tk.clipboard';
import TKTracker from '@tk/components/tracker/tk.tracker';
import TKTracking from '@tk/components/tracker/tk.tracking';
import { configureStore } from '@tk/utilities/tk.use.store';
import TKHeadingNav from '@tk/components/tk.heading.nav';
import TKFileLink from '@tk/components/tk.file.link';
import TKLightGallery from '@tk/components/tk.light.gallery';
import LMVZButton from './controls/LMVZButton';

import 'tippy.js/dist/tippy.css';
import '@scss/modules/general.scss';

const compareStore = new TKCompareStore();

configureStore({
    compareStore,
});

export default class General extends TKModuleFactory {
    constructor() {
        super([
            ...headerComponents,
            { name: 'tk-manager', constructor: TKManager },
            { name: 'tk-tracker', constructor: TKTracker },
            { name: 'tk-status-console', constructor: TKStatusConsole },
            { name: 'tk-clipboard', constructor: TKClipboard },
            { name: 'tk-carousel', constructor: TKCarousel },
            { name: 'tk-context-menu', constructor: TKContextMenu },
            { name: 'tk-flag', constructor: TKFlag },
            { name: 'tk-product-tile', constructor: TKProductTile },
            { name: 'tk-product-variants', constructor: TKProductVariants },
            { name: 'tk-tooltip', constructor: TKTooltip },
            { name: 'tk-dialog', constructor: TKDialog },
            { name: 'tk-article-list', constructor: TKArticleList },
            { name: 'tk-price', constructor: TKPrice },
            { name: 'tk-stock', constructor: TKStock },
            { name: 'tk-static-content', constructor: TKStaticContent },
            { name: 'tk-favorite-button', constructor: TKFavoriteButton },
            { name: 'tk-favorite-info', constructor: TKFavoriteInfo },
            { name: 'tk-form-element', constructor: TKFormElement },
            { name: 'tk-form-validator', constructor: TKFormValidator },
            { name: 'tk-tabs-accordion', constructor: TKTabsAccordion },
            { name: 'tk-compare-button', constructor: TKCompareButton },
            { name: 'tk-selection', constructor: TKSelection },
            { name: 'tk-file-upload-area', constructor: TKFileUploadArea },
            { name: 'tk-tracking', constructor: TKTracking },
            { name: 'tk-heading-nav', constructor: TKHeadingNav },
            { name: 'tk-file-link', constructor: TKFileLink },
            { name: 'tk-light-gallery', constructor: TKLightGallery },
            { name: 'lmvz-button', constructor: LMVZButton },
        ]);
    }
}

new General();
